<template>
  <v-container fluid class="main">
    <h1>방문절차안내</h1>
    <v-row>
      <v-col cols="12">
      <section>
        <ul>
          <li class="step01"><span>방문신청</span></li>
          <li class="arrow"></li>
          <li class="step02"><span>피방문자 통보</span></li>
          <li class="arrow"></li>
          <li class="step03"><span>내부승인</span></li>
          <li class="arrow"></li>
          <li class="step04"><span>방문수속</span></li>
          <li class="arrow"></li>
          <li class="step05"><span>방문</span></li>
        </ul>
        </section>
      </v-col>
      <v-col cols="12" class="margintop45">
        <v-card class="box02">
          <v-card-title>방문예약 서비스 소개</v-card-title>
          <div class="boxCon">
            <v-card-text>
                <p>방문을 원하시는 분은 「방문예약 신청하기」를 클릭하여 방문 예약을 해주세요.</p>
                <p>신청 내역은 「방문신청조회」를 클릭하면 확인이 가능합니다.</p>
            </v-card-text>
            <v-btn class="resBtn"
              to="/home/agreeTerms"
              block
              color="#023894"
              dark
              depressed
              large
            >방문예약 신청하기</v-btn>
            <v-btn class="resBtn"
              to="/home/search"
              block
              color="#78BE20"
              dark
              depressed
              large
            >방문신청조회</v-btn>
          </div>
        </v-card>
      </v-col>
      <!--<v-col cols="12" lg="6" xl="6">
        <v-card class="box02 infoBox">
          <v-card-title>공지사항</v-card-title>
          <div class="boxCon">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>방문예약 서비스 안내</v-list-item-title>
                <v-list-item-subtitle>2021년 3월 2일</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>점검안내</v-list-item-title>
                <v-list-item-subtitle>2021년 3월 12일</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-card>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
p {
    font: 1.4rem 'NanumSquare', sans-serif;
}
</style>